import RequestDataCollectorAPI from './request-data-collector-api';

export default RequestDataCollectorAPI;
